const GRAPH_TYPES = {
  VERTICAL: 'VERTICAL',
  STACKED: 'STACKED',
  OVERTIME: 'OVERTIME',
  KEY_FINDINGS: 'KEY_FINDINGS',
};
export default GRAPH_TYPES;
